import { useEffect } from "react";

// Most-used pages (Tasks also holds the task edit form); fetched once the app is idle.
const PAGES = [
  () => import("@/pages/tracker/Tasks"),
  () => import("@/pages/tracker/MyWork"),
  () => import("@/pages/tracker/Board"),
  () => import("@/pages/tracker/ReviewQueue"),
];

// Quietly download page code after sign-in so the first open is as fast as later ones.
export function usePrefetchPages(enabled) {
  useEffect(() => {
    if (!enabled) return undefined;
    const run = () => PAGES.forEach((load) => load().catch(() => {}));
    const idle = window.requestIdleCallback
      ? (fn) => window.requestIdleCallback(fn, { timeout: 5000 })
      : (fn) => setTimeout(fn, 0);
    const timer = setTimeout(() => idle(run), 2500);
    return () => clearTimeout(timer);
  }, [enabled]);
}
